export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail eller användarnamn',
      invalidEmailOrUsername: 'Ogiltig e-mail eller användarnamn',
      invalidPassword: 'Ogiltigt lösenord',
      noInternetConnection: 'Ingen internetanslutning',
      pageNotFound_title: 'Sidan Kunde Inte Hittas',
      password: 'Lösenord',
      projectManagement: 'Projektledning',
      serverConnectionFailed: 'Server connection failed',
      unknownError: 'Okänt fel, försök igen senare',
    },

    action: {
      logIn: 'Logga in',
    },
  },
};
